import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Pill } from 'ui-components/components/pill';

import { useSellerFormattedDate } from '../../../../../../../hooks/use-datetime-formats';
import { messages } from '../messages';
import style from '../manage-add-ons.module.less';

const AddOnNameColumnId = 'addOnName';

const addOnNameBuilder = ({ content }) => {
  return content.name;
};

const AddOnNameCell = ({ cell }) => {
  const { displayName, isAlphaUser, isTrial, deactivationDateTimeUtc, isIncludedInPlan } = cell.value;
  const shouldNotShowDeactivationPill = isIncludedInPlan || isAlphaUser;
  const formattedDateString = useSellerFormattedDate(deactivationDateTimeUtc);
  return (
    <div className={style['add-on-name-cell']}>
      {isTrial ? (
        <Text
          className={style['add-on-name']}
          formattedMessageValues={{ addOnName: displayName }}
          textType={TextType.Paragraph}
          value={messages.addOnNameWithTrial}
        />
      ) : (
        <Text
          className={style['add-on-name']}
          formattedMessageValues={{ addOnName: displayName }}
          textType={TextType.Paragraph}
          value={displayName}
        />
      )}
      {!shouldNotShowDeactivationPill && !!deactivationDateTimeUtc && (
        <Pill
          className={style['deactivation-pill']}
          label={<FormattedMessage {...messages.deactivationDate} values={{ deactivationDt: formattedDateString }} />}
          theme='neutral'
        />
      )}
    </div>
  );
};

const createAddOnNameColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.addOn} />,
  accessor: AddOnNameColumnId,
  Cell: AddOnNameCell,
  width: 3,
  className: style['justify-end'],
});

AddOnNameCell.propTypes = {
  cell: PropTypes.object.isRequired,
};

export { AddOnNameColumnId, addOnNameBuilder, createAddOnNameColumnDefinition };
